export default function ConsentSettingsButton({ className = "", testId = "consent-settings-button" }) {
  const openConsentSettings = () => window.dispatchEvent(new Event("pimp-open-consent"));
  return <button className={className} onClick={openConsentSettings} data-testid={testId}>Gérer les cookies</button>;
}